import React, { memo } from 'react';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import EntityMenu from 'containers/components/EntityMenu';
import SearchList from 'containers/components/SearchList';
import { getLiteral } from 'utils/getLiteral';
import { useSelector } from 'react-redux';
import { canManageMarketingCampaigns } from './utils/marketingCampaignPermissions';

const Menu = memo(({ config }) => {
    const canCreate = useSelector(canManageMarketingCampaigns);
    return (
        <EntityMenu
            entity={CAMPAIGNS_MARKETING}
            canCreate={canCreate}
            withFilters={true}
            quickFilters={config.quickFilters}
            addButtonLabel={getLiteral('label_marketing_campaigns_create_email')}
            searchComponent={
                <SearchList
                    entity={CAMPAIGNS_MARKETING}
                    placeholder={getLiteral('placeholder_search_campaign')}
                    useAsSimpleSearch={true}
                />
            }
        />
    );
});

export default Menu;
